import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { FACTORY_ADDRESS } from "utils/Constants"
import { formatAddress } from "utils/Functions"
import { querySmartContract } from "utils/RpcHelper"

export function TokenListPage() {
    const [tokenDetails, setTokenDetails] = useState<{ token_address: string, burn_address: string }[]>([])

    const loadTokenDetails = async () => {
        const { tokens } = await querySmartContract(FACTORY_ADDRESS, { registered_token: {} })
        setTokenDetails(tokens)
    }

    useEffect(() => {
        loadTokenDetails()
    }, [])


    return <div className="w-100 p-2 px-4">
        <h4>Available token to burn</h4>
        <div className="preview-list">
            {
                tokenDetails.map(e => <TokenDetailItem burn_address={e.burn_address} token_address={e.token_address} />)
            }
        </div>
    </div>
}


function TokenDetailItem(prop: { token_address: string, burn_address: string }) {
    const navigate = useNavigate()
    const [detail, setDetail] = useState<{ name: string, symbol: string }>();

    const loadTokenDetail = async () => {
        const res = await querySmartContract(prop.token_address, { token_info: {} })
        setDetail(res)
    }

    useEffect(() => {
        loadTokenDetail()
    }, [])

    return <div className="preview-item border-bottom">
        <div className="preview-thumbnail">
            <div className="preview-icon bg-success">
                <i className="mdi mdi-coin"></i>
            </div>
        </div>
        <div className="preview-item-content d-flex flex-grow">
            <div className="flex-grow">
                <h6 className="preview-subject">{detail?.name} ({detail?.symbol})</h6>
                <p className="text-muted mb-0">{formatAddress(prop.token_address)}</p>
            </div>
            <button onClick={() => navigate("/burn/" + prop.burn_address)} type="button" className="btn btn-primary">Burn</button>
        </div>
    </div>
}